import {API} from '../../api/API';
import { USER_ACCOUNT_URL,BUSINESS_ACCOUNT_TYPES_URL } from '../../config/config';

export async function listUserAccounts () {
    let response = await API.get(USER_ACCOUNT_URL);
    return response.data;
}


export async function listAccountTypes () {
    let response = await API.get(BUSINESS_ACCOUNT_TYPES_URL)
    return response.data;
}
